import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    authControllerSwitchTenantV1: build.mutation<
      AuthControllerSwitchTenantV1ApiResponse,
      AuthControllerSwitchTenantV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/auth/switch-tenant`,
        method: 'POST',
        body: queryArg.switchTenantBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type AuthControllerSwitchTenantV1ApiResponse =
  /** status 200 Returns a new access token scoped to the target tenant */ SwitchTenantResponse;
export type AuthControllerSwitchTenantV1ApiArg = {
  switchTenantBody: SwitchTenant;
};
export type SwitchTenantResponse = {
  /** JWT access token */
  accessToken: string;
};
export type SwitchTenant = {
  /** Tenant ID to switch to */
  tenantId?: number;
  /** Tenant slug to switch to (alternative to tenantId) */
  tenantSlug?: string;
};
